import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { RequestEntity } from 'types';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
	IDishWithAdditionalField,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Dish.module.scss';

interface IDish {
	data: IDishWithAdditionalField[];
	subcategoryID: string;
}

export const Dish: React.FC<IDish> = ({ data, subcategoryID }) => {
	const { deleteDishFromSubcategory } = useContext<IDishAssignmentContext>(DishAssignmentContext);

	return (
		<div data-test="Dish">
			{data.map((dish) => {
				const containerClasses = classNames(style.container, { [style.addedDish]: dish.isAddedDishFromList });

				return (
					<div className={containerClasses} key={dish.id + 'dishTab'}>
						<div className={style.name}>
							<div className={style.imgWrapper}>
								<ImgUploaderByEntityId
									resource={RequestEntity.DishesMenuV2}
									entityID={dish.filePath ? dish.id : ''}
									isMenuV2={true}
									photoSize="Small"
									loaderSize="small"
								/>
							</div>
							<Text className={style.dishName} translationKey={dish.name} withTooltip={true} />
						</div>
						<div className={style.categories}>
							{dish.categories.map((el, i) => {
								const isNeedComma = i !== dish.categories.length - 1;
								return (
									<Text
										key={el + 'categories' + i.toString()}
										translationKey={`${el}${isNeedComma ? ', ' : ''}`}
										withTooltip={true}
									/>
								);
							})}
						</div>
						<div className={style.subcategories}>
							{dish.subCategories.map((el, i) => {
								const isNeedComma = i !== dish.subCategories.length - 1;
								return (
									<Text
										key={el + 'subcategories' + i.toString()}
										translationKey={`${el}${isNeedComma ? ', ' : ''}`}
										withTooltip={true}
									/>
								);
							})}
						</div>
						{dish.externalId ? (
							<ChunkOfTextWithCopying className={style.externalId} text={dish.externalId} />
						) : (
							<Text className={style.externalId} translationKey="-" />
						)}
						<Text className={style.price} translationKey={String(dish.price)} withTooltip={true} />
						<svg
							className={style.closeIcon}
							onClick={() => deleteDishFromSubcategory(subcategoryID, dish.id)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};
